export const RECORD_TYPES = [
  {
    key: "temperature",
    title: "Temperatures",
    subtitle: "Control diari dels equips de fred",
    frequency: "DIARI",
    icon: "Thermometer",
    color: "terracotta",
    isDaily: true,
  },
  {
    key: "pest",
    title: "Plagues",
    subtitle: "Inspecció visual diària",
    frequency: "DIARI",
    icon: "Bug",
    color: "forest",
    isDaily: true,
  },
  {
    key: "reception",
    title: "Recepció",
    subtitle: "Mercaderies entrades",
    frequency: "PER ENTRADA",
    icon: "PackageCheck",
    color: "ink",
    isDaily: false,
  },
  {
    key: "incidence",
    title: "Incidències",
    subtitle: "I mesures correctores",
    frequency: "QUAN CALGUI",
    icon: "TriangleAlert",
    color: "ember",
    isDaily: false,
  },
  {
    key: "formation",
    title: "Formació",
    subtitle: "Activitats formatives",
    frequency: "QUAN CALGUI",
    icon: "GraduationCap",
    color: "ink",
    isDaily: false,
    apiKey: "training",
  },
  {
    key: "cleaning",
    title: "Neteja",
    subtitle: "Neteja i desinfecció",
    frequency: "SEGONS PLA",
    icon: "SprayCan",
    color: "forest",
    isDaily: false,
  },
];

export const LOGO_URL = "/logo.svg";

// Ordre fix de les categories de fitxes de producció
export const SHEET_CATEGORIES = [
  "Picades i bases",
  "Burger meat",
  "Hamburgueses",
  "Albòndigues",
  "Salsitxa i chistorra",
  "Empanats",
  "Redondos",
  "Broquetes",
  "Ales",
  "Altres",
];

// Recursos vinculats a cada pla APPCC (per a la pàgina de plans)
export const PLAN_RESOURCES = {
  2: [
    { to: "/cleaning-products", label: "Productes de neteja (FT)" },
    { to: "/history", label: "Registres de neteja" },
  ],
  3: [{ to: "/history", label: "Registres de plagues" }],
  4: [{ to: "/history", label: "Registres de formació" }],
  5: [
    { to: "/providers", label: "Proveïdors", admin: true },
    { to: "/albaran-templates", label: "Models d'albarà (IA)", admin: true },
    { to: "/history", label: "Registres de recepció" },
  ],
  6: [{ to: "/history", label: "Registres de temperatures" }],
  7: [
    { to: "/allergens", label: "Matriu d'al·lèrgens" },
    { to: "/production", label: "Fitxes de producció" },
  ],
  8: [{ to: "/history", label: "Registres d'incidències" }],
};
